module.exports = __webpack_public_path__ + "img/vpc-patform.77c4c81.png";